
import React from 'react'
import Contact from "./components/pages/contact/Contact"
import Home from "./components/pages/home/Home"
import About from "./components/pages/about/About"
import {BrowserRouter ,Route, Routes,useParams} from "react-router-dom"
import Login from './components/pages/login_form/Login'
import Register from './components/pages/login_form/Register'
import Department from './components/pages/department/Department'
function App() {
  return (
    <>
    <BrowserRouter>
      <Routes>

        <Route path='/' element={<Home/>}></Route>
        <Route path='/about' element={<About/>}></Route>
        <Route path='/contact' element={<Contact/>}></Route>
        <Route path='/login' element={<Login/>}></Route>
        <Route path='/register' element={<Register/>}></Route>
        <Route path='/department' element={<Department/>}></Route>
      
      </Routes>
    </BrowserRouter>

    </>
  )
}

export default App